import React from "react";

function joinClasses(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ResultViewHeader({ title, recordingTime, icon = null }) {
  const time = recordingTime?.time || "";
  const date = recordingTime?.date || "";

  return (
    <div className="flex flex-col w-full h-fit items-start text-left gap-0.5">
      <div className="flex items-center gap-2">
        {icon ? (
          <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary [&_svg]:h-6 [&_svg]:w-auto [&_svg]:fill-current [&_svg]:stroke-current">
            {icon}
          </span>
        ) : null}
        <h1 className="subtitle-text">{title}</h1>
      </div>
      {time || date ? (
        <p className="muted-text">
          {time} {date}
        </p>
      ) : null}
    </div>
  );
}

function ResultViewScaffold({
  title,
  recordingTime,
  icon = null,
  children,
  details = null,
  footer = null,
  outerClassName = "",
  summaryClassName = "",
}) {
  return (
    <div
      className={joinClasses(
        "w-full max-w-lg h-full min-h-0 overflow-y-auto",
        outerClassName,
      )}
    >
      <section className="min-h-fit p-4 pt-0 sm:pt-4 flex flex-col items-stretch gap-4">
        <div
          className={joinClasses(
            "w-full h-fit flex flex-col gap-4 justify-start items-stretch text-left",
            summaryClassName,
          )}
        >
          <ResultViewHeader
            title={title}
            recordingTime={recordingTime}
            icon={icon}
          />
          {children}
        </div>
      </section>

      {details}

      {footer ? <div className="w-full p-4 pt-0">{footer}</div> : null}
    </div>
  );
}

export default ResultViewScaffold;
